import { useDispatch, useSelector } from 'react-redux';
import ReportSearch from './ReportSearch';
import { Box } from '@material-ui/core';
import { handleEtaDeliveryRateReport, openEtaDeliveryRateReport } from '../../reducers/uiSlice';
import UniDialog from '../Common/UniDialog';
import { useTranslation } from 'react-i18next';

function EtaDeliveryRateReport() {
    const {t} = useTranslation('etaDeliveryRateReport');
    const dispatch = useDispatch();

    const openModal = useSelector(openEtaDeliveryRateReport);

    return (
        <UniDialog
            title={t('title_eta_delivery_rate_report')}
            fullWidth
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <Box>
                <ReportSearch/>
            </Box>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleEtaDeliveryRateReport(false))
    }
}

export default EtaDeliveryRateReport;